import { useLayoutEffect } from 'react';
import { HubCarouselSection } from '@/components/Hub/HubCarouselSection';
import type { HubSection } from '@/components/Hub/hubSectionTypes';

export interface HubSectionSlotProps {
    section: HubSection;
    /** Lets the panel show its empty message once every section has reported nothing. */
    onHasContentChange?: (id: string, hasContent: boolean) => void;
    hasAlternateSurface?: boolean;
}

// Calls the hook first and decides emptiness after, which is the point of the component.
// Skipping an empty section's hook instead would change hook order between renders.
export const HubSectionSlot = ({ section, onHasContentChange, hasAlternateSurface }: HubSectionSlotProps) => {
    const data = section.useData();
    const hasContent = data.isLoading || (!data.isError && data.slides.length > 0);

    // Before paint so the nav never shows a section that is about to hide.
    useLayoutEffect(() => {
        onHasContentChange?.(section.id, hasContent);
    }, [section.id, hasContent, onHasContentChange]);

    if (!hasContent) {
        return null;
    }

    return <HubCarouselSection section={section} data={data} hasAlternateSurface={hasAlternateSurface} />;
};
